import React from "react";

export default function MySQL_ISNULL() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_ISNULL</h1>
      <p>This is the MySQL_ISNULL component generated from the SQL JSON.</p>
    </div>
  );
}
